/* PDFCommunity (v46): small helpers for the content pages.
   - guides: filter the cards by topic (without JavaScript all cards stay visible)
   - contact: (v80) the form sends the message through /contact-send.php on
     our own server; if that fails, the visitor's own mail program opens
     (mailto:) with the message filled in.
   - "copy address" button
   All texts come from data-attributes in the page, so this file has no
   language strings of its own. */
(function () {
  'use strict';

  function filters() {
    var btns = document.querySelectorAll('.chip-btn[data-filter]');
    if (!btns.length) return;
    var cards = document.querySelectorAll('.guide-card[data-cat]');
    [].forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        [].forEach.call(btns, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        [].forEach.call(cards, function (c) { c.hidden = !(f === 'all' || c.getAttribute('data-cat') === f); });
      });
    });
  }

  var FEEDBACK_SUBJECT_INDEX = 1, FEEDBACK_TOOL_MAX = 60;
  /* (v147) What the server (PHP FILTER_VALIDATE_EMAIL) accepts, so the visitor
     gets the field message instead of the fallback to the mail app: ASCII
     only (an IDN domain such as bü.de is refused there), no dot at the start
     or end of the name or twice in a row, domain labels of letters, digits
     and inner hyphens, a top-level domain that starts with a letter (no bare
     IP address). Quoted names and [IP] addresses, which the server would
     take, are left out: type=email refuses them anyway. */
  var EMAIL_MAX = 254, EMAIL_NAME_MAX = 64, EMAIL_LABEL_MAX = 63;
  var EMAIL_RE = /^[!#-'*+\/-9=?^-~-]+(?:\.[!#-'*+\/-9=?^-~-]+)*@(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.)+(?:[a-z][a-z0-9]*|xn--[a-z0-9]+)(?:-+[a-z0-9]+)*$/i;
  function emailOk(v) {
    if (v.length > EMAIL_MAX || v.indexOf('@') > EMAIL_NAME_MAX || !EMAIL_RE.test(v)) return false;
    return v.split('@')[1].split('.').every(function (label) { return label.length <= EMAIL_LABEL_MAX; });
  }
  function contact() {
    var form = document.getElementById('ct-form');
    if (!form) return;
    var msg = form.querySelector('textarea'), sel = form.querySelector('select'), status = form.querySelector('.ct-status');
    // (v79) coming from a "Feedback" link: subject "problem with a
    // conversion" (2nd option on every language's page) and a short
    // template with the tool's name, taken from the link
    var q = new URLSearchParams(location.search);
    if (q.has('feedback') && !msg.value) {
      sel.selectedIndex = FEEDBACK_SUBJECT_INDEX;
      msg.value = (form.getAttribute('data-feedback') || '').replace('{tool}', () => (q.get('tool') || '').slice(0, FEEDBACK_TOOL_MAX));
    }
    var email = form.querySelector('#ct-email'), trap = form.querySelector('.ct-hp input'), btn = form.querySelector('button[type=submit]');
    var openedAt = Date.now();
    function say(key, warn) { status.textContent = form.getAttribute(key); status.classList.toggle('warn', !!warn); }
    // (v90) a field error is tied to the field (aria-invalid + aria-describedby
    // to the status line) and taken off again as soon as the visitor types
    if (!status.id) status.id = 'ct-status';
    function fieldError(field, key) {
      say(key, true);
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', status.id);
      field.focus();
    }
    [msg, email].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', function () { f.removeAttribute('aria-invalid'); f.removeAttribute('aria-describedby'); });
    });
    function mailApp(subject, text) {
      var href = 'mailto:' + form.getAttribute('data-to') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(text);
      location.href = href;
    }
    // (v80) the message is sent through /contact-send.php on our own server;
    // when that fails (offline, no PHP, server error) the visitor's mail app
    // opens instead, as before, so a message is never lost silently
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = (msg.value || '').trim();
      if (!text) { fieldError(msg, 'data-empty'); return; }
      // (v142, v147) as strict as the server: "a@b", "a.@b.com" or "a@bü.de" pass type=email but not FILTER_VALIDATE_EMAIL
      if (email && email.value && (!email.checkValidity() || !emailOk(email.value.trim()))) { fieldError(email, 'data-bad-email'); return; }
      var subject = '[PDFCommunity] ' + sel.value;
      var body = new FormData();
      body.append('subject', sel.value);
      body.append('message', text);
      body.append('email', email ? email.value.trim() : '');
      body.append('pc_hp_x', trap ? trap.value : '');
      body.append('elapsed', String(Math.round((Date.now() - openedAt) / 1000)));
      body.append('lang', (document.documentElement.lang || '').slice(0, 2));
      btn.disabled = true;
      say('data-sending');
      fetch('/contact-send.php', { method: 'POST', body: body, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { ok: false }; })
        .then(function (res) {
          if (!res || res.ok !== true) throw new Error('not sent');
          msg.value = ''; if (email) email.value = '';
          say('data-sent');
        })
        .catch(function () {
          say('data-fallback', true);
          mailApp(subject, text);
        })
        .then(function () { btn.disabled = false; });
    });
  }

  function copy() {
    [].forEach.call(document.querySelectorAll('.copy-btn[data-copy]'), function (b) {
      var label = b.textContent;
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-copy');
        function say(attr) { b.textContent = b.getAttribute(attr) || label; setTimeout(function () { b.textContent = label; }, 2000); }
        function done() { say('data-copied'); }
        function failed() { say('data-copy-failed'); } // (v140) the address stays visible to copy by hand
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, failed);
        else {
          var t = document.createElement('textarea'); t.value = v; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          var ok = false; try { ok = document.execCommand('copy'); } catch (e) { ok = false; } // (v140) false or an error: copying was refused
          if (ok) done(); else failed();
          t.remove();
        }
      });
    });
  }

  function init() { filters(); contact(); copy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
